import {fetchCourierLocation} from 'api/requests';
import {useEffect, useState} from 'react';
import {IGeoLocation} from 'types';
import logger from 'utils/logger';

interface Props {
  courierId?: number;
  shouldRequest?: boolean;
}

const useCourierLocation = ({courierId, shouldRequest}: Props) => {
  const [courierLocation, setCourierLocation] = useState<IGeoLocation | undefined>();

  const getCourierLocation = () => {
    if (!courierId) return logger.logDebug('OrderDetailsMap', 'No courier id');
    fetchCourierLocation(courierId)
      .then((res) => {
        setCourierLocation(res);
      })
      .catch((err: any) => {
        logger.error(err);
      });
  };

  useEffect(() => {
    if (!shouldRequest) return;
    getCourierLocation();
    const interval = setInterval(() => {
      getCourierLocation();
    }, 2 * 60 * 1000);
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courierId, shouldRequest]);

  if (!courierId) return;
  return courierLocation;
};

export default useCourierLocation;
